var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGift = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6.048 9C5.414 8.145 5 7.127 5 6a6 6 0 0 1 11-3.318A6 6 0 0 1 27 6c0 1.127-.414 2.145-1.048 3H31.5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5H30v14.5a.5.5 0 0 1-.5.5h-27a.5.5 0 0 1-.5-.5V17H.5a.5.5 0 0 1-.5-.5v-7A.5.5 0 0 1 .5 9zM7 6a4 4 0 0 1 8-.004V6q-.001.784-.01 1.442c-.005.608-.01 1.13-.001 1.558h-6.06a6 6 0 0 1-.348-.252C7.578 7.962 7 6.974 7 6m5 5v4H2v-4zm2 0v4h4v-4zm9.072-2q.179-.12.347-.252C24.422 7.962 25 6.974 25 6a4 4 0 0 0-8 0q.001.784.01 1.442c.005.608.01 1.13.001 1.558zM20 11v4h3v2h-3v13h8V17h-1v-2h3v-4zm-2 19V17h-4v13zM4 17h8v13H4z",
  clipRule: "evenodd"
})));
export default SvgGift;